import { CSSProperties } from "react";

export default {
  wrapper: {
    position: "fixed",
    top: 80,
    left: "50%",
    width: 300,
    marginLeft: -150,
    zIndex: 2000,
    textAlign: "center",
    backgroundColor: "rgba(255,255,255,0.7)",
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 10,
  },
  buttonConfirm: {
    width: 100,
    display: "inline-block",
    fontSize: 15,
    background: "#444",
  },
  buttonClose: {
    marginLeft: 100,
  },
  image: {
    width: "250",
    border: "solid 5px #444",
  },
} as Record<string, CSSProperties>;
